export const FONTS = {
  regular: 'Calibre-regular',
  semiBold: 'Calibre-semibold',
  medium: 'Calibre-medium'
};
